var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !!_vm.isSubFormChildWidget(),
              expression: "!!isSubFormChildWidget()",
            },
          ],
          attrs: { label: _vm.i18nt("designer.setting.widgetColumnWidth") },
        },
        [
          _c("el-input", {
            attrs: { type: "text" },
            model: {
              value: _vm.optionModel.columnWidth,
              callback: function ($$v) {
                _vm.$set(_vm.optionModel, "columnWidth", $$v)
              },
              expression: "optionModel.columnWidth",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }